import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import riskAssessmentService from "../../services/riskAssessmentService";

const useRiskAssessmentActions = (riskAssessmentId) =>
    useQuery(
        [
            queryKeys.riskAssessmentActions,
            riskAssessmentId,
        ],
        () => riskAssessmentService.fetchRiskAssessmentActions(riskAssessmentId),
        {
            enabled: !!riskAssessmentId,
        }
    );

export default useRiskAssessmentActions;
